import { Typography } from '@evocolabs/orkaui'
import Twitter24 from '@evocolabs/icons/lib/Twitter24'
import Facebook24 from '@evocolabs/icons/lib/Facebook24'
import Email24 from '@evocolabs/icons/lib/Email24'
import Linkedin24 from '@evocolabs/icons/lib/Linkedin24'
import { classes } from '@/src/components/Blog/[blogTitle].module.js'

export const ShareBox = () => {
  return (
    <div className={classes.shareBox}>
      <Typography variant="Body2" color="#4E4947">
        Share this article
      </Typography>
      <div
        style={{
          gap: '16px',
          display: 'flex'
        }}
      >
        <a
          onClick={() => {
            window.open(
              `https://www.facebook.com/sharer/sharer.php?u=${document.URL}&amp;src=sdkpreparse`,
              'facebook',
              'popup=1'
            )
          }}
          style={{ cursor: 'pointer' }}
        >
          <Facebook24 forceFill="#756F6E" />
        </a>
        <a
          onClick={() => {
            window.open(
              `https://twitter.com/share?url=${document.URL}`,
              'twitter',
              'popup=1'
            )
          }}
          style={{ cursor: 'pointer' }}
        >
          <Twitter24 forceFill="#756F6E" />
        </a>
        <a
          onClick={() => {
            window.location.href = `mailto:?subject=I wanted you to see this site&amp;body=Check out this site ${document.URL}.`
          }}
          style={{ cursor: 'pointer' }}
        >
          <Email24 forceFill="#756F6E" />
        </a>
        <a
          onClick={() => {
            window.open(
              `https://www.linkedin.com/sharing/share-offsite/?url=${document.URL}`,
              'linkedin',
              'popup=1'
            )
          }}
          style={{ cursor: 'pointer' }}
        >
          <Linkedin24 forceFill="#756F6E" />
        </a>
      </div>
    </div>
  )
}
